import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';
import 'react-toastify/dist/ReactToastify.css';
import originalFetch from 'isomorphic-fetch';


class UserProjectTeamStatsService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.USER_PROJECT_TEAM_STATS = '/api/user-project-team-stats';
    
        this.GET_BY_PROJECT_AND_USER_AND_TEAM = '/project/{projectId}/user/{userId}/team/{teamId}';
        this.GET_LIST_BY_PROJECT_AND_TEAM = '/list/project/{projectId}/team/{teamId}';
    }

    async getByProjectAndUserAndTeam(projectId, userId, teamId) {
        let url = window.location.origin + this.USER_PROJECT_TEAM_STATS + this.GET_BY_PROJECT_AND_USER_AND_TEAM;
        url = url
            .replace('{projectId}', projectId)
            .replace('{userId}', userId)
            .replace('{teamId}', teamId);
        try {
            const releaseDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return releaseDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getListByProjectAndTeam(projectId, teamId) {
        let url = window.location.origin + this.USER_PROJECT_TEAM_STATS + this.GET_LIST_BY_PROJECT_AND_TEAM;
        url = url
            .replace('{projectId}', projectId)
            .replace('{teamId}', teamId);
        try {
            const releaseDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return releaseDataRet;
        } catch (err) {
            console.log(err);
        }
    }

}

export default UserProjectTeamStatsService;